import { UPDATE_LOADER } from '../actions/constants'

const initialState = {
  loadingData: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_LOADER:
      return {
        ...state,
        loadingData: action.payload,
      }

    default:
      return {
        ...state,
      }
  }
}
